module.exports = __webpack_public_path__ + "img/britishInternationalCollegeOfCairo.938f084e.png";